<template>
    <div>
        <h1>Rakentajana Karanteenissa</h1>
        <blockquote>
            meidän visuaalisten ja luovien ihmisten arvo. Heidän tehtävä on rakentaa palvelimen päärakennukset. Jos
            yhtään katselette ympärille, tajuatte, että se on heidän käsialaa kokonaisuudessaan. He ovat samalla
            viivalla moderaattoreiden kanssa ja toimivat varalla vain, mikäli palvelimella ei ole moderaattoria tai
            ylempää paikalla. Rakentajien tehtäviin EI KUULU nahisteluiden selvittäminen!
            <span>karanteeni.net/ylläpito</span>
        </blockquote>
        <p>Siitä voi kukin itse tulkita.</p>
        <p>Rakentajana rakennetaan, mutta kannattaa (ja pitää) myös opetella moderaattorin tehtävät.</p>
        <h2>
            Lista Rakentajana aukeavista oikeuksista
        </h2>
        <div class="command-list">
            <Command command="wesv" params="toggle" desc="Näyttää world edit valinnan rajat" />
        </div>
        <ul class="command-list">
            <li>+Kaikki Moderaattorina aukeavat</li>
            <li>Worldedit (ks. netistä worldedit) Kokeile! Älä kaada.</li>
            <li>:)</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'rakentaja',
    props: {},
    metaInfo: {
        title: 'Rakentajana'
    }
}
</script>

<style scoped></style>
